import { useCanGoBack, useRouter } from '@tanstack/react-router';
import { legacySelfCareHome } from '../../config/redirects';
import { env } from '../../config/runtime';
import type { BackBehavior } from '../definePageRoute';
import { RouterPaths } from '../routePaths';

export function useGoBackOrHome(fallback: string = RouterPaths.index.path, options?: { behavior?: BackBehavior }) {
  const { navigate, history } = useRouter();
  const canGoBack = useCanGoBack();
  return () => {
    // `'legacy'` pages were entered from the old self-care app, so "back" leaves the SPA.
    // `assign` (not `replace`) keeps the browser's own back button pointing at this page.
    if (options?.behavior === 'legacy') {
      return window.location.assign(legacySelfCareHome(env.waipuDomain));
    }
    return canGoBack ? history.back() : navigate({ to: fallback });
  };
}
